import React from "react";
import LoginForm from "../components/common/LoginForm";

const LoginPage = () => {
  return (
    <>
      <div>
        <LoginForm LoginFrom="LoginPage" />
      </div>
    </>
  );
};

export default LoginPage;
